import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const LoyaltyProductModal = ({ show, onHide, handleChange, handleSubmit, formData }) => {


    return (
        <Modal show={show} onHide={onHide} size="md">
            <Modal.Header closeButton>
                <Modal.Title>Add Loyalty Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Product</Form.Label>
                        <Form.Control type="text" name="product" value={formData.product} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Points</Form.Label>
                        <Form.Control type="number" name="points" value={formData.points} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Valid Until</Form.Label>
                        <Form.Control type="date" name="valid_until" value={formData.valid_until} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Check type="checkbox" label="Is Menu Item?" name="is_menu_item_flag" checked={formData.is_menu_item_flag} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control as="textarea" rows={4} name="description" value={formData.description} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Image</Form.Label>
                        <Form.Control type="file" name="image" onChange={handleChange} />
                    </Form.Group>

                    <Button variant="primary" type="submit">Submit</Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default LoyaltyProductModal;
